import { useState } from "react";
import styles from "./MarketPlaceDetail.module.css";

function DynamicPlanInterval({
  handleClose,
  heading,
  placeholder,
  type,
  typeId,
  value,
  isOneTime,
  setStateVal,
  handleSavePlan_interval,
  adminVendorId,
}) {
  const [intervalNumber, setIntervalNumber] = useState(
    value?.n_interval ? value?.n_interval : "1",
  );
  const [intervalUnit, setIntervalUnit] = useState(
    value?.interval ? value?.interval : "day",
  );
  const [typeName, setTypeName] = useState(value?.name ? value?.name : "");
  const [templateType, setTemplateType] = useState(
    value?.template ? value?.template : "recurring",
  );
  const [typeError, setTypeError] = useState(false);

  const intervalNumberHandler = (e) => {
    const value = e.target.value;
    if (
      /^\d*$/.test(value) &&
      !value.startsWith("0") &&
      !value.startsWith("-")
    ) {
      setIntervalNumber(value);
    }
  };

  return (
    <div>
      <div onClick={handleClose} className={styles.backdrop}></div>
      <div className={styles.TypeContainer}>
        <h1 className={styles.heading}>{heading}</h1>
        {type === "plan" &&
          value.vendor_id &&
          value.vendor_id !== adminVendorId && (
            <p style={{ color: "red" }}>
              *Can't Edit Type created by other vendors
            </p>
          )}
        <div className={styles.planTypeField}>
          {type === "plan" && (
            <>
              <input
                type="text"
                className={styles.typeInput}
                value={typeName}
                onChange={(e) => setTypeName(e.target.value)}
                placeholder={placeholder}
                required={true}
                readOnly={value.vendor_id && value.vendor_id !== adminVendorId}
              />
              <select
                required
                disabled={
                  value?.allow_delete === false ||
                  (value.vendor_id && value.vendor_id !== adminVendorId)
                }
                className={styles.nIntervalSelect}
                value={templateType}
                onChange={(e) => setTemplateType(e.target.value)}
              >
                <option value="recurring">T1 (Subscription)</option>
                <option value="credit">T2 (Credit)</option>
                <option value="one_time">T3 (Onetime)</option>
              </select>
              <button
                className={styles.AddTypeBtn}
                onClick={() => {
                  if (typeName === "") {
                    setTypeError(true);
                    return;
                  } else {
                    setStateVal({
                      skuId: "",
                      parentId: "",
                      levels: "",
                      name: typeName,
                      template: templateType,
                      vendor_id: adminVendorId,
                    });
                    setTimeout(() => {
                      handleSavePlan_interval({
                        skuId: "",
                        parentId: "",
                        levels: "",
                        name: typeName,
                        template: templateType,
                        vendor_id: adminVendorId,
                      });
                    }, 0);
                  }
                }}
              >
                Save
              </button>
            </>
          )}
          {type === "interval" && (
            <>
              <span className={styles.nIntervalLabel}>Every</span>
              <div className={styles.nIntervalContainer}>
                <input
                  type="number"
                  placeholder="Enter number"
                  required
                  className={styles.nIntervalInput}
                  min={1}
                  value={intervalNumber}
                  disabled={intervalUnit === "lifetime"}
                  onChange={intervalNumberHandler}
                  onWheel={(e) => e.target.blur()}
                />
                <select
                  required
                  className={styles.nIntervalSelect}
                  value={intervalUnit}
                  onChange={(e) => setIntervalUnit(e.target.value)}
                >
                  <option value="day">Days</option>
                  <option value="week">Weeks</option>
                  <option value="month">Months</option>
                  <option value="year">Years</option>
                  {isOneTime && <option value="lifetime">No Expiry</option>}
                </select>
              </div>
              <button
                className={styles.AddTypeBtn}
                onClick={() => {
                  setStateVal({
                    n_interval: intervalNumber,
                    interval: intervalUnit,
                    typeId: typeId,
                    allow_delete: true,
                    vendor_id: adminVendorId,
                  });
                  setTimeout(() => {
                    handleSavePlan_interval({
                      n_interval: intervalNumber,
                      interval: intervalUnit,
                      typeId: typeId,
                      allow_delete: true,
                      vendor_id: adminVendorId,
                    });
                  }, 0);
                }}
              >
                Save
              </button>
            </>
          )}
        </div>
        {typeError && (
          <p className={styles.typeError}>Plan Type filed is required</p>
        )}
      </div>
    </div>
  );
}

export default DynamicPlanInterval;
